import { selectionOutcomeTypeMapper } from "../selectionOutcomeTypeMapper";
/**
 * Get selection side in FullBetSlip format
 * @param {Selection} selection Selection to process
 * @return {number} The corresponding number for Selection side
*/
export var getSelectionSide = function (selection) {
    return selection.outcomeType && selectionOutcomeTypeMapper[selection.outcomeType];
};
//# sourceMappingURL=getSelectionSide.js.map